// for the view to monitor when it's time to close
PegasusTemplate.LaunchPlatformController = Em.Controller.extend({
  currentUserSkinName: null,
  isNativeHost: false,
  isDeluxeHost: false,
  isDoneLaunching: false
});

PegasusTemplate.LaunchPlatformController.reopen({
  isEditorComplete: false,
  isRetrieveComplete: false,
  viewDidLoad: function(){
    var keys = Object.keys(this.get('inventory'));
    keys.forEach(function(key){
      PegasusTemplate[key].find();
    });
  },
  didRetrieve: function(type){
    var key = type.toString().split('.').get('lastObject'),
      blocking = this.get('inventory');

    blocking[key].didRetrieve = true;

    var loaded = Object.keys(blocking).every(function(key){
      return blocking[key].didRetrieve;
    });
    if ( !loaded ) { return; }

    this.set('isRetrieveComplete', true);
  }
});

PegasusTemplate.LaunchPlatformController.reopen({
  inventory: {
    Block: {
      didRetrieve: false
    }
  }
});

